import { Feature } from "@/core/feature-flags/Feature.js";
import { FeatureFlagsRepository } from "@/core/feature-flags/feature-flags.repository.js";

export class FeatureFlagsManager {
  constructor() {
    /**
     * @private
     * @type {Map<string, Feature>}
     */
    this._flags = new Map();

    FeatureFlagsRepository.getFlags().then(response => {
      for (const code in response) {
        this._flags.set(code, new Feature(code, response[code].enabled, response[code].value));
      }
    });
  }

  /**
   * @param {string} code
   * @param {boolean} byDefault
   * @returns {Feature}
   */
  feature(code, byDefault = false) {
    if (this._flags.has(code)) {
      return this._flags.get(code);
    }

    return new Feature(code, byDefault, null);
  }
}
